const UPDATE_FACULTY_SEARCH = '@@search/UPDATE_FACULTY_SEARCH';
const UPDATE_POPUP_SEARCH = '@@search/UPDATE_POPUP_SEARCH';
const CLEAR_SEARCH = '@@search/CLEAR_SEARCH';
const CLEAR_POPUP_SEARCH = '@@search/CLEAR_POPUP_SEARCH';
const UPDATE_FACULTY_FILTER = '@@search/UPDATE_FACULTY_FILTER';
const CLEAR_FILTER = '@@search/CLEAR_FILTER';
const UPDATE_STUDENTS = '@@search/UPDATE_STUDENTS';
const CLEAR_PLACEHOLDER = '@@search/CLEAR_PLACEHOLDER';
const UPDATE_PLACEHOLDER = '@@search/UPDATE_PLACEHOLDER';

export default {
	UPDATE_FACULTY_SEARCH,
	UPDATE_POPUP_SEARCH,
	CLEAR_SEARCH,
	CLEAR_POPUP_SEARCH,
	UPDATE_FACULTY_FILTER,
	CLEAR_FILTER,
	UPDATE_STUDENTS,
	CLEAR_PLACEHOLDER,
	UPDATE_PLACEHOLDER,
};
